import React, { useContext } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AgencyIQUserManagementWrapper from '../AgencyIQUserManagement/UserManagementWrapper';
import UserManagementWrapper from '../UserManagement/UserManagementWrapper';
import { UserContext } from '../UserContext';

export function UserSettings() {
  const match = useRouteMatch();
  const { user } = useContext(UserContext);
    const isSiaaAgency = user.isSiaaAgency();

  return (
    <Switch>
      <Route>
        {isSiaaAgency ? (
          <AgencyIQUserManagementWrapper />
        ) : (
          <UserManagementWrapper />
        )}
      </Route>
    </Switch>
  );
}
